define('base/view',['require','exports','module','backbone','underscore','base/vent'],function(require, exports, module) {
  "use strict";

  var Backbone = require("backbone"),
      _ = require("underscore");

  require("base/vent");

  var View = Backbone.View.extend({
    constructor: function(options) {
      this.options = options || {};
      this.events = this.events || {};
      _.each(this.triggers, function(eventName, domEvt) {
        this.events[domEvt] = _.bind(this.domTrigger, this, eventName);
      }, this);
      if (options) { _.extend(this, _.pick(options, "data", "parent")); }
      View.__super__.constructor.apply(this, arguments);
      if (this.model && this.model.on && !this.options.noBinding) {
        this.listenTo(this.model, "change", this.render);
      }
      if (this.viewModel && this.viewModel.on && !this.options.noBinding && !this.ignoreViewModel) {
        this.listenTo(this.viewModel, "change", this.render);
      }
    },
    domTrigger: function(eventName, e) {
      // e.stopPropagation();
      e.preventDefault();
      this.trigger(eventName, this, this.model);
    },
    serializeModel: function(model) {
      var data = {};
      model = arguments.length === 0? this.model : model;
      if (model) {
        _.extend(
          data,
          _.result(model, model.serialize? "serialize" : "toJSON")
        );
      }
      return data;
    },
    serializeHelpers: function() {
      var data = {};
      if (typeof(this.helpers) === "function") {
        _.extend(data, this.helpers());
      } else {
        _.extend(data, this.helpers);
      }
      return data;
    },
    serializeData: function() {
      var data = this.serializeModel();
      _.extend(data, this.serializeModel(this.collection));
      _.extend(data, this.serializeModel(this.viewModel));
      _.extend(data, this.serializeHelpers());
      return data;
    },
    render: function() {
      if (this.noTemplate) { return this; }
      var data = this.serializeData(),
          html = this.template(data);
      this.$el.empty().append(html);
      this.trigger("render", this);
      this.triggerMethod("render");
      return this;
    },
    remove: function() {
      this.triggerMethod("remove");
      module.exports.__super__.remove.call(this);
    }
  });

  module.exports = View;

});

